export { Connection, PROGRESS, ERRORS, PERMISSION_ERROR } from '@iobroker/socket-client';
